<template>
  <div id="RentalAgreementList">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
              <div class="page-name">
                  <div class="page-title"> {{pageTitle}}</div>
                  <!-- Button for Clear Cache -->
                  <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                  <div class="btn-groups text-right">
                      <a href="javascript:void(0)" class="btn btn-secondary mr-2" v-on:click="exportReports()">
                          <i class="fp-export"></i> Export
                      </a>
                      <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backHeaderList">
                        <i class="fp-back"> </i> Back
                    </button>
                      <!--router-link v-if="addAgreement && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'RentalAgreementCreate'}" >
                          <i class="fp-add"></i> Add
                      </router-link-->
                  </div>
              </div>
              <div class="container-fluid">
                  <div class="admin-page-content rental-agreement-list">
                      <!-- <div class="btn-groups badge-buttons text-left mb-3">
                          <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                              <button type="button" v-on:click="getRentalAgreement(this)" :class="'btn btn-secondary'">Pending / Active</button>
                              <button type="button" v-on:click="getRentalAgreement(this)" :class="'btn btn-secondary'">Expired</button>
                          </div>
                      </div> -->
                      <!-- <div class="FiltersLabel">Filters</div> -->
                      <data-table-filter-config :moduleName="'scopRaterentalAgreementList'" ref="filterComponent" @cancelSelection="cancelAll"></data-table-filter-config>
                      <section class="bg-white data-table">
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange" :moduleName="'scopRaterentalAgreementList'" :position="'top'">
                              </custom-pagination>

                              <vue-good-table
                                  ref="listRentalAgreementTable"
                                  mode="remote"
                                  title="Rental Agreement"
                                  @on-page-change="onPageChange"
                                  @on-selected-rows-change="selectionChanged"
                                  @on-column-filter="onColumnFilter"
                                  @on-per-page-change="onPerPageChange"
                                  @on-sort-change="onSortChange"
                                  @on-select-all="onSelectAll"
                                  :totalRows="totalRecords"
                                  :columns="userColumns"
                                  :rows="rows"
                                  :pagination-options="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      dropdownAllowAll: false,
                                  }"
                                  :select-options="{
                                  enabled: rental_agreement_value,
                                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                  selectionInfoClass: 'custom-class',
                                  selectionText: 'rows selected',
                                  clearSelectionText: 'clear',
                                  }"
                                  :search-options="{
                                  enabled: false,
                                  }">
                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                      <div :key="key">
                                          <div v-if="props.column.field == 'code'">
                                              <template v-if="viewAgreement">
                                                  <router-link title="View Agreement Details" class="color-blue"  v-bind:to="{name: 'RentalAgreementView',params:{id:props.row.id}}">{{props.row.code}}</router-link>
                                              </template>
                                              <template v-else>
                                                  {{props.row.code}}
                                              </template>
                                          </div>
                                          <div v-else-if="props.column.field == 'action'">
                                              <template v-if="(updateAgreement && props.row.closed == 0 && props.row.status.toLowerCase() == 'pending') || canEditAfterClose">
                                                  <router-link title="Edit Rental Agreement" class="fp-edit" v-bind:to="{name: 'RentalAgreementEdit',params:{id:props.row.id}}"></router-link>
                                              </template>
                                              <template>
                                                  <span v-if="(updateAgreement && props.row.closed == 0 && props.row.status.toLowerCase() == 'pending') || canEditAfterClose" class="">&nbsp;|&nbsp;</span>
                                                  <a href="javascript:void(0)" title="Agreement Download" v-on:click="generateAgreementPdf(props.row.id)">
                                                      <i class="fp-export"></i>
                                                  </a>
                                              </template>
                                          </div>
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                      </div>
                                  </template>
                                  <div slot="selected-row-actions">
                                      <button id="deleteRentalAgreementBtn" v-on:click.prevent="RentalAgreementUpdateRate" class="btn btn-primary">Update Rate</button>
                                  </div>
                              </vue-good-table>
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange">
                              </custom-pagination>
                      </section>
                  </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
      </div>
      <!--div class="modal fade add-extra-charge-popup" id="agreementModal" ref="agreementModal" data-backdrop="static" data-keyboard="false" aria-labelledby="agreementModal" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="myModal1">Process Agreement</h5>
                  </div>
                  <div class="modal-body">
                      <form id="SelectDates" class="form-inline addinspectionForm">
                          <div class="form-row row-cols-md-4 row-cols-1">
                              <div class="col form-group">
                                  <label class="control-label require">Effective Date</label>
                                  <div class="input-group">
                                      <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                      <label for="effective_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                  </div>
                                  <div class="field-error">{{effective_date_error_msg}}</div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                      <button class="btn btn-primary" id="addProcessAgreementBtn" v-on:click="processAgreement()">
                          <i class="fp-submit"></i> Process
                      </button>
                      <button type="button" class="btn btn-tertiary" id="cancelprocessAgreementBtnBtn" data-dismiss="modal">
                          <i class="fp-close"></i> Cancel
                      </button>
                  </div>
              </div>
          </div>
      </div-->
  </div>

</template>

<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';


export default {
  name: "RentalAgreementList",
  metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Rental Agreement List | " +process.env.COPYRIGHT_NAME
  },
  mixins:[commonMixins,dataTableMixins],
  data: () => ({
      pageTitle : "Scope Active Rental Agreement List",
      hideButton:false,
      firstLoad: 0,
      permissions: [],
      cantAccessPage: "",
      userColumns:[],
      columns: [
          {
              label: 'Actions',
              field: 'action',
              sortable: false,
              hidden:false,
          },
          {
              label: 'Code',
              field: 'code',
              fpFieldType:"text",
              filterable: true,
              hidden: false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Customer',
              field: 'customer_id',
              fpFieldType:"text",
              filterable: true,
              hidden: false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Customer", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Asset',
              field: 'vehicle_type_id',
              fpFieldType:"text",
              filterable: true,
              hidden: false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Asset Type", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Contract Type',
              field: 'contract_type',
              fpFieldType:"option",
              filterable: true,
              hidden: false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Contract Type", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'From Date',
              field: 'actual_out_datetime',
              fpFieldType:"date",
              filterable: true,
              hidden: false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "MM/DD/YYYY", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'To Date',
              field: 'actual_in_datetime',
              fpFieldType:"date",
              hidden: false,
              filterable: true,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "MM/DD/YYYY", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Status',
              field: 'status',
              fpFieldType:"option",
              hidden:false,
              filterable: true,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Status", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter", //only trigger on enter not on keyup
                  filterDropdownItems:["Active","Pending","Expired"]
              }
          },
          {
              label: 'Location',
              field: 'location',
              fpFieldType:"option",
              hidden:false,
              filterable: true,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Location", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
      ],
      rows: [],
      totalRecords: 0,
      rental_agreement_value: false,
      loading:false,
      updateAgreement:false,
      addAgreement: false,
      viewAgreement:false,
      effective_date:'',
      optionsDate: {
          format: 'MM/DD/YYYY',
          useCurrent: false,
          toolbarPlacement:'bottom',
          widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
          },
      },
      action:'list',
      effective_date_error_msg:"",
      pageKey:"_rental_agreement_list_",
      canEditAfterClose:false,
      truckTypes: [],
      scopeRates: [],
  }),
  watch:{

      //check permission change
      permissions: function (permissions) {

          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'list_rental_agreement') {
                      self.cantAccessPage = true;
                  }
                  if (permissions[i].name == 'delete_rental_agreement') {
                    if(self.$route.query.flag == 'rentalReport'){
                      self.rental_agreement_value = false;
                    } else {
                      self.rental_agreement_value = true;
                    }

                  }
                  if (permissions[i].name == 'add_rental_agreement') {
                      self.addAgreement = true;
                      self.updateAgreement = true;
                  }
                  if (permissions[i].name == 'view_rental_agreement') {
                      self.viewAgreement = true;
                  }
                  if ( permissions[i].name == 'edit_after_close_agreement' ) {
                      self.canEditAfterClose = true;
                  }


              }
          }

      }

  },
  created: function() {

  },
  mounted: function() {
      var self = this;

      //self.loadList();
      self.getPermissions();

      self.truckTypes = atob(self.$route.query.type);
      self.truckTypes = self.truckTypes.split(",");
      self.scopeRates = atob(self.$route.query.section);
      self.scopeRates = self.scopeRates.split(",");

        if(self.$route.query.flag == 'rentalReport'){
        self.hideButton = true;
        self.pageTitle = "Rental Listing";

        for (let index = 0; index < this.columns.length; index++) {

            if(this.columns[index].field == 'action'){
                this.$set(this.columns[index], 'hidden', true);
            }

        }
      }
  },
  methods: {
      backHeaderList() {
        var self = this;
        self.$router.go(-1);
      },
      cancelAll: function (cancelAll) {
        this.$refs.listRentalAgreementTable.unselectAllInternal();
      },

      selectionChanged(param) {
          var self = this;
          self.serverParams.selectedAll = false;
          if(param.selectedRows.length == 100) {
            EventBus.$emit('clear-selection', false);
          } else {
            EventBus.$emit('clear-all-flags', false);
          }
          return;

      },
      exportReports: function() {
          var self = this;
          this.action = "export";
          this.loadList();
      },
      RentalAgreementUpdateRate: function() {

        var self = this;
        self.loading = true;


        var data = this.$refs['listRentalAgreementTable'].selectedRows;
        var selectedRows = [];

        var path = window.location.pathname;
        var segments = path.split("/");

        for (var i = 0; i < data.length; i++) {
            selectedRows.push(self.$refs['listRentalAgreementTable'].selectedRows[i].id)
        }


        var fields = {
            selectedRows:selectedRows,
            scopeRates:self.scopeRates,
        };


        $.ajax({
              url: process.env.ROOT_API + "/scope/rate-update/" + segments[3],
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                    selectedRows.forEach(element => {
                      var idx = self.rows.findIndex(obj => obj.id == element);
                      if (idx != -1) {
                        self.rows.splice(idx, 1);
                      }
                    });
                    if(self.rows.length == 0) {
                      self.$swal('','Rate Updated Successfully','success');
                      self.backHeaderList();
                    }
                  }else{

                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'rental-agreement-list')
              }
          });

      },

      loadList() {
          var self = this;
          self.loading = true;
          var data = this.$refs['listRentalAgreementTable'].selectedRows;
          var selectedRows = [];

          var path = window.location.pathname;
         var segments = path.split("/");

          for (var i = 0; i < data.length; i++) {
              selectedRows.push(self.$refs['listRentalAgreementTable'].selectedRows[i].id)
          }
          var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              all:self.serverParams.selectedAll,
              selectedRows:selectedRows,
              action:self.action,
              truckTypes:self.truckTypes
          };
          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/scope/rentalagreement/" + segments[3],
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                      if ( self.action == "export" ) {

                          self.action = "list";
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {

                              self.excel = data.content.web;
                              var save = document.createElement("a");
                              save.href = self.excel;
                              save.download = data.content.web;
                              save.target = "_blank";

                              document.body.appendChild(save);
                              save.click();
                              document.body.removeChild(save);
                              self.$refs.listRentalAgreementTable.unselectAllInternal();

                          }
                              self.loadList();
                      }else if ( self.action == "delete" ) {

                          self.action = "list";
                          $("#deleteRentalAgreementBtn").val("Delete");

                          self.$refs.filterComponent.clearSelectAll();
                          self.loadList();
                          EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                      }else{
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                          self.filteredFlag = false;
                      }
                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;
                      self.filteredFlag = false;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if ( self.action == "delete" ) {
                      self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-delete')
                  }else{
                      self.generateStatusCodeMessage(jqXHR,false,'rental-agreement-list')
                  }

              }
          });
      },

      
      generateAgreementPdf(id){

          var self = this;

          self.loading = true ;
          $.ajax({
                  url: process.env.ROOT_API + "/rentalagreement/pdf",
                  type: "POST",
                  data: {
                      id:id
                  },
                  headers: this.ajxHeaders,
                  dataType: 'json',
                  success: function (data) {
                      self.loading = false ;
                      var link = document.createElement('a');
                      document.body.appendChild(link);
                      link.href = data.content;
                      link.download = '';
                      link.target = "_blank";
                      link.click();
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      self.generateStatusCodeMessage(jqXHR,false,'rental-agreement-generate-pdf')
                  }
              });

      },
      openAgreementModal: function(){
          var self = this;

          self.effective_date = '';
          // self.invoice_required = false;
          $("#agreementModal").modal('show');
      },
     
  }

}
</script>

<style scope>
.set-margin{
    margin-right: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScopeAgreementList.vue